/* eslint-disable import/default, import/no-webpack-loader-syntax */
import 'common/utils/local-storage-polyfill';

// app dependencies
import 'client/styles/main.scss';

// app
import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { IS_DEVEL } from 'utils/environment';
import Root from 'client/Root';

if (!IS_DEVEL) {
	Sentry.init({
		dsn: 'https://e6ced77cc723478fad969f5f3ba00b06@o969560.ingest.sentry.io/5920728',
		integrations: [new Integrations.BrowserTracing()],

		// Set tracesSampleRate to 1.0 to capture 100%
		// of transactions for performance monitoring.
		// We recommend adjusting this value in production
		tracesSampleRate: 0.05,
		release: `story-cards@${process.env.VERSION}`,
		environment: process.env.NODE_ENV,
	});
}

if (process.env.DEBUG !== undefined) {
	localStorage.setItem('debug', process.env.DEBUG);
}

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
	// <React.StrictMode>
	<Root />
	// </React.StrictMode>
);
